import React from 'react';
import { useFilterState } from '../state';
import FilterBtn from '../FilterBtn';
import DspxPopover from '../../../../../../../../components/DspxPopover/DspxPopover';
import Content from './content';
import { ReactComponent as FilterIcon } from '../../../../../../../../resource/AdaptiveFilterIcon.svg';
import { getPopupContainer } from '../utils';
import styles from './index.module.scss';

const CustomFilter = ({ name, renderContent }) => {
  const {
    value,
    setValue,
    visible,
    onVisibleChange,
    onOk,
    onReset,
    hasFilterValue,
  } = useFilterState(name);

  return (
    <DspxPopover
      overlayClassName={styles.root}
      arrow={false}
      trigger="click"
      visible={visible}
      onVisibleChange={onVisibleChange}
      getPopupContainer={getPopupContainer}
      placement="bottomLeft"
      content={
        <Content onOk={onOk} onReset={onReset}>
          {renderContent({ value, onChange: setValue })}
        </Content>
      }
    >
      <FilterBtn iconComponent={FilterIcon} active={hasFilterValue} />
    </DspxPopover>
  );
};

export default CustomFilter;
